<template lang="pug">
.product-details.container.mx-auto.px-4(ref="container")
    .product-wrap
        .loading(v-if="loading" key="spinner")
            //- TODO: skeleton
            Spinner(:size="10" :thickness="2")
        .details(v-else-if="product" :class="[{ hasThumbnails: media.length > 1},{ thumbnails2Rows: media.length >= 6 }, transition]" key="details")
            .media(ref="media")
                .active-media(v-if="activeMedia && mediaWidth")
                    ProductImage(
                        v-if="activeMedia.type === 'image'"
                        :key="`main-${activeMedia.id}`"
                        :media="activeMedia"
                        :product="product"
                        :preferred-width="mediaWidth"
                    )
                .placeholder(v-else)
                    svg(xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512' fill="#d5d5d5")
                        path(d='M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 96c0-35.3-28.7-64-64-64H139.6l40.5 32H512c17.7 0 32 14.3 32 32V265.4l-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0l-31 31 25.3 20 28.4-28.4c3.1-3.1 8.2-3.1 11.3 0L544 310.6v40.7l32 25.3V96zM297.6 319.8l-9.6 9.6-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0L96 329.4V160.7L64 135.4V416c0 35.3 28.7 64 64 64H500.4l-40.5-32H214.6L322.8 339.8l-25.3-20zM265.4 352l-96 96H128c-17.7 0-32-14.3-32-32V374.6l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0L265.4 352z')
            .thumbnails(v-if="media.length > 1")
                template(v-for="(el, m) in media")
                    //- :aspect-ratio="9 / 16"
                    PreviewImage(
                        v-if="el.type === 'image'"
                        :key="el.id"
                        :media="el"
                        :product="product"
                        :preferred-width="72"
                        :maximized="el.id === activeMedia.id"
                        @maximize="data => selectMedia(m)"
                    )
            .zoom-container.info
                .info-grid
                    .basic-data
                        h2.name {{ name }}
                        .nr Artikel-Nr. {{ nr.replace(/^[^-]*-[^-]*-/,'') }}
                    .price
                        nobr(:class="{ strikethrough: salePrice }") {{ price }}
                        nobr.sale(v-if="salePrice") {{ salePrice }}
                        .tax-info(v-if="!customer || !customer.show_net_prices") Inkl. MwSt ({{ taxRate }})
                .description.mb-4(v-if="product.description")
                    label <strong>Beschreibung</strong>
                    .value(v-html="product.description")
                .properties
                    ProductProperty(
                        v-for="property in properties"
                        v-if="property.label === 'Länge in Gr. 38' || property.label === 'Obermaterial' || property.label === 'Futter'"
                        :valid="valid"
                        :key="`${product.id}-${property.id}`"
                        :property="property"
                        :active-option="selectedOptions[property.id]"
                        :sellable-articles="sellableArticles"
                        :valid-articles="validArticles"
                        :manage-stock="product.manage_stock"
                        @select="selectPropertyOption"
                    )
                label.care <strong>Pflegehinweise</strong>
                img.carelabel-image(v-if="careLabelImage" :src="careLabelImage")
                //- img.label-image(v-if="labelImage.title.length" :title="labelImage.title" :alt="labelImage.title" :src="labelImage.url")    
                //.buttons(v-if="valid" :class="{ active: validPropertySelection && validArticles && validArticles.length === 1 }")
                    .left
                        .custom-number-input
                            button.decrease(@click="qty = Math.max(1, qty - 1)")
                                span.m-auto.text-2xl.font-thin &minus;
                            input.border-black.border-solid.border-1(type="number" name="custom-input-number" v-model="qty")
                            button.increase(@click="qty = Math.min(maxQty, qty + 1)")
                                span.m-auto.text-2xl.font-thin +
                    .right
                        button.button.add-to-shopping-cart(v-if="valid" @click="addToCart") In den Warenkorb
        .not-found(v-else key="not-found")
            Error.error(:code="404" message="Produkt konnte nicht gefunden werden")

    .preorder-table
        Preorder(
          v-if="product != undefined"
          :valid="valid"
          :article-properties="articleProperties"
          :product-properties="configurableProductProperties"
          :articles="product.articles"
          :valid-articles="validArticles"
          :selected-options="selectedOptions"
          :manage-stock="product.manage_stock"
          @select-property="selectPropertyOption"
          @toggle-active-article="toggleActiveArticle"
        )

</template>

<script>
import { debounce } from '@/helpers';
import product from '@/extensions/shop/mixins/product';

export default {
    name: 'ProductDetailPage',
    data: () => ({
        loading: false,
        product: undefined,
        transition: {
            // transition classes
            'slide-fade-enter': true,
            'slide-fade-enter-active': false,
            'slide-fade-leave-active': false,
            'slide-fade-leave-to': false
        }
    }),
    mixins: [product],
    mounted() {
        this.loading = true;

        this.fetchProduct({ slug: this.$route.params.product })
            .then(product => {
                this.product = product;
                // this.setProduct(product);
                setTimeout(this.calculateMediaWidth, 0);

                this.transition['slide-fade-enter-active'] = true;
                setTimeout(() => (this.transition['slide-fade-enter'] = false), 0);
                setTimeout(() => (this.transition['slide-fade-enter-active'] = false), 300);
            })
            .finally(() => {
                this.loading = false;
            });

        this.debouncedCalculateMediaWidth = debounce(this.calculateMediaWidth, 100);
        window.addEventListener('resize', this.debouncedCalculateMediaWidth);
    },
    beforeRouteLeave(to, from, next) {
        this.transition['slide-fade-leave-active'] = true;
        this.transition['slide-fade-leave-to'] = true;
        next();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.debouncedCalculateMediaWidth);
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.product-details
    margin-top: 20px
    @apply mb-8
    @screen lg
        margin-top: 2rem

.loading > section
    min-height: 140px

.thumbnails
    @apply flex justify-evenly flex-wrap mt-4
    @screen md
        @apply mt-0
    .preview-image
        @apply m-2
        @screen md
            @apply m-0
    @screen md
        @apply grid gap-4 grid-cols-2 auto-rows-min auto-cols-min
    @screen lg
        @apply grid-cols-1
.thumbnails2Rows .thumbnails
    @screen lg
        @apply grid-cols-2

.preorder-table
    @apply mt-8


label
    font-weight: 500
    color: #000
    font-size: 16px

.properties
    // margin-bottom: 3rem
    .property
        // margin-bottom: 1rem
.info-grid
    @apply text-left mt-4
    @screen md
        @apply mt-0
    .name
        @apply text-2xl
        line-height: 1
        margin-bottom: 0.5rem
        @apply md
            font-size: 2rem
        small
            font-size: 1rem
            top: -0.3rem
            position: relative
    .nr
        @apply mb-8
        @screen lg
            @apply mb-12
    .price
        @apply text-2xl mb-4
        line-height: 1
        @screen md
            @apply ml-6 mb-0
            text-align: right
            font-size: 2rem
        .tax-info
            margin-top: 0.5rem


.details
    position: relative
    ::v-deep .drift-zoom-pane
        @apply rounded overflow-hidden
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 80vh

.add-to-shopping-cart
    @apply bg-gray-900 border-gray-600 rounded-none text-xs
    @screen lg
        @apply text-base

.buttons
    @apply flex
    justify-content: space-between
    opacity: .2
    pointer-events: none
    transition: opacity .15s ease
    margin-bottom: 5rem
    &.active
        pointer-events: initial
        opacity: 1
    .left
        display: flex
        flex-grow: 1
        justify-content: flex-start
        padding-right: 1rem

.custom-number-input
    @apply w-32 flex flex-row rounded-lg relative
    button
        @apply bg-white text-gray-600 h-full w-20 cursor-pointer outline-none
        height: 2.5rem
        &:hover,
        &:focus
            @apply text-gray-700 bg-gray-100
        &.decrease
            @apply rounded-l
        &.increase
            @apply rounded-r
    input
        @apply outline-none rounded-none text-center w-full bg-white font-semibold flex items-center text-gray-700
        @apply shadow-none #{! important}
        height: 2.5rem
        &:hover,
        &:focus
            @apply text-black

@screen md
    .product-details
        display: flex
        flex-direction: column
        & > div
            width: 100%
        .loading
            display: flex
            width: 100%
        .details
            display: grid
            grid-template-rows: auto
            grid-template-columns: minmax(0, 300px) auto
            grid-gap: 3rem
            &.hasThumbnails
                @apply auto-rows-auto
                grid-template-columns: 238px 150px minmax(0, 1fr)
                grid-gap: 1rem
                @screen lg
                    grid-template-columns: 404px 72px minmax(0, 1fr)
                .info
                    margin-left: 1.5rem
            &.hasThumbnails.thumbnails2Rows
                grid-template-columns: 238px 160px minmax(0, 1fr)
                @screen lg
                    grid-template-columns: 322px 160px minmax(0, 1fr)

    .info-grid
        @apply relative text-right
        @screen lg
            @apply grid text-left
            grid-template-rows: max-content auto
            grid-template-columns: auto max-content
        .description
            grid-column: 1/3
        ::v-deep .drift-zoom-pane
            @apply rounded overflow-hidden
            position: absolute
            left: -5rem
            top: 0
            width: calc(100% + 5rem)
            height: 60vh

@screen lg
    .product-details .details
        grid-gap: 6rem


input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button
    -webkit-appearance: none
    margin: 0

.custom-number-input input:focus
    outline: none !important

.custom-number-input button:focus
    outline: none !important

.strikethrough
  font-size: 0.8em
  opacity: 0.6
  color: $black
  &:before
    border-color: theme('colors.gray.700')

.price
  position: relative
  .tax-info
    font-size: 1rem
    margin-bottom: 0.5rem
.price nobr + nobr.sale
  margin-left: 1rem
  color: theme('colors.red.600')
  position: relative
  z-index: 1
  &:before
    content: ''
    position: absolute
    // background-color: theme('colors.red.100')
    background-color: #e6ff15
    width: calc(100% + 8px)
    height: calc(100% + 4px)
    left: -4px
    top: -7px
    z-index: -1
    transform: rotate(-9deg) skew(-2deg, 0deg)

.description.mb-4
    white-space: break-spaces    

.description.mb-6
    white-space: break-spaces

.label-image
    max-height: 150px
    max-width: 150px

label.care
    margin-top: 1.5rem  
.carelabel-image
    max-width: 220px
    margin-left: -4px        
    margin-bottom: 1.5rem    

.placeholder
  padding-bottom: 100%
  // padding-bottom: calc(100% * 610/422)
  position: relative
  background: rgba(0,0,0,0.05)
  svg
    // width: 100%
    // height: 100%
    position: absolute
    // top: 0
    // left: 0
    // line
    //   stroke: rgba($red, .3)
    //   stroke-width: 1.02
    left: calc(50% - 3.5rem)
    top: calc(50% - 2.5rem)
    width: 7rem
    g
      fill: #d5d5d5
      .cls-2
        fill: #f2f2f2 !important
</style>
